import React, { useCallback, useEffect } from "react";
import { getCoursesForDownloadsPage } from "../../selectors/courseSelectors";
import { connect } from "react-redux";
import DownloadsCourseMenu from "./DownloadsCourseMenu";


function DownloadsCourseMenuContainer(props) {
  const { dispatch, courses } = props;

  useEffect(() => {
    dispatch({ type: "DOWNLOADS_COURSE_CHANGED", activeCourseId: courses[0]?.id });
  }, [courses[0]?.id]);

  const handleCourseChange = useCallback(
    ({ name: courseId }) => {
      dispatch({ type: "DOWNLOADS_COURSE_CHANGED", activeCourseId: courseId });
    },
    [dispatch]
  );

  return (
    <DownloadsCourseMenu
      {...props}
      handleCourseChange={handleCourseChange}
    />
  );
}

function mapStateToProps(state) {
  return {
    courses: getCoursesForDownloadsPage(state),
    activeCourseId: state.downloads.activeCourseId,
  };
}

export default connect(mapStateToProps)(DownloadsCourseMenuContainer);
